AppSettingAPIService = ($http, $q, cache) ->

  getAppSetting: (params={}) ->
    appSetting = cache.get("appSetting")
    delay = $q.defer()
    unless appSetting
      $http.get('/api/settings/app.json', params: params).then(
        (resp) ->
          cache.put("appSetting", resp.data)
          delay.resolve resp.data
        (error) ->
          delay.resolve null
      )
    else
      delay.resolve appSetting
    delay.promise

  update: (params) ->
    $http.put('/api/settings/app.json', params).then ->
      cache.remove("appSetting")

AppSettingAPIService.$inject = [
  '$http'
  '$q'
  'cache'
]

module.exports = AppSettingAPIService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/remote-api/app-setting-api-service.coffee